export default __webpack_public_path__ + "static/17-eye-scanner-46712456f891caf81a8c23a3ea6f697f.png";